var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navigation"},[_c('button',{staticClass:"circle-icon-container",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}},[_c('img',{attrs:{"src":require('@/images/back-black-icon.svg')}})]),_c('h1',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }